import type { Site } from '@xing-com/crate-xinglet';

type Permutations<T, U = T> = [T] extends [never]
  ? []
  : T extends T
    ? [T, ...Permutations<Exclude<U, T>>]
    : never;

export const SITES: Permutations<Site> = [
  'crate',
  'xing',
  'xing-login',
  'lebenslauf',
  'brewery',
  'demo',
  'router-demo',
];
